import { Controller } from "@hotwired/stimulus"

// Records that a visitor started the contact form on a business profile:
// the first focus or input inside it, once per page. A profile view is not a
// contact attempt; "Viewed Organization" already counts those.
export default class extends Controller {
  static values = { organizationId: Number, sourceContext: String }

  connect() {
    this.started = false
    this.start = this.start.bind(this)
    this.element.addEventListener("focusin", this.start)
    this.element.addEventListener("input", this.start)
  }

  disconnect() {
    this.element.removeEventListener("focusin", this.start)
    this.element.removeEventListener("input", this.start)
  }

  start() {
    if (this.started) return
    this.started = true
    this.element.dataset.contactFormStarted = "true"
    if (!window.ahoy) return

    window.ahoy.track("organization_contact_form_started", {
      organization_id: this.organizationIdValue,
      source_context: this.sourceContextValue || "profile"
    })
  }
}
